import { Component } from '@angular/core';
import {AppService} from "../../../app-common/services/app/app.service";
import {ProblemDetails} from "../../../app-common/data/problemDetails";
import {FeedbackService} from "../../services/feedback/feedback.service";

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent {
  popupVisible: boolean = false;
  feedback: string = '';

  constructor(public appService: AppService,
              private feedbackService: FeedbackService) {
  }

  togglePopup(): void {
    this.popupVisible = !this.popupVisible;
  }

  resetForm(): void {
    this.feedback = '';
  }

  closePopup(): void {
    this.resetForm();
    this.togglePopup();
  }

  async submitFeedback(event: Event): Promise<void> {
    event.preventDefault();
    if (!this.feedback) {
      this.appService.showErrorMessage('Please fill Feedback.');
      return;
    }

    const feedbackData = {
      Content: this.feedback,
    };

    this.feedbackService.sendFeedbackEmail(feedbackData).then(() => {
        this.appService.showSuccessMessage('Feedback has been sent successfully.');
        this.resetForm();
        this.togglePopup();
    }).catch(error => {
      if (error instanceof ProblemDetails) {
        this.appService.showErrorMessage('There was an error while sending the email. Please contact Administrator. support@godatahub.com');
      }
    });

  }
}
